import React from 'react';
import { SketchPicker } from 'react-color'
import { View, Text } from 'react-native';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import CustomFormInput from './CustomFormInput';

export default class CustomColorPicker extends CustomFormInput {
    constructor(props, context) {
        super(props, context);
        
        this.state          = { displayColorPicker: false };
        this.handleClick    = this.handleClick.bind(this);
        this.handleClose    = this.handleClose.bind(this);
    }

    handleClick() {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    }
    
    handleClose() {
        this.setState({ displayColorPicker: false })
    }
    
    _onChange(color) {
        if(color)
            this.props.onChangeText(color.hex);
        else
            this.props.onChangeText(null);
    }
    
    getElement() {
        let props = this.getSupportedProps();

        return <>
            <View className={'colorpicker'} onClick={ this.handleClick }>
                <View className={'colorpicker-dot'} style={{backgroundColor: props.value || props.placeholder}} />
                <Text className={'colorpicker-text'} style={{color: props.value || props.placeholder || '#ccc'}}>{props.value || props.placeholder}</Text>
                {props.value && !this.props.mandatory && ( <TouchableArea role="button" className={['color-picker-clear']} title="clear" onPress={() => this._onChange(null)}><View className={'rc-time-picker-clear-icon'}></View></TouchableArea>)}
            </View>
            {this.state.displayColorPicker && (
                <View className={'colorpicker-popover'}{...(this.props.inline ? {style: {position: 'static'}} : {})}>
                    <View className={'colorpicker-popover-cover'} onClick={ this.handleClose } />
                    <SketchPicker color={ props.value || props.placeholder || '#fff' } onChange={ this._onChange } />
                </View>)
            }
        </>;
    }
}